let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lLx4a")).then(() => parcelRequire('2JrnR'));